import { paymentGateway } from "./paymentGateway";

export const handlePayment = async (options) => {
  try {
    const paymentData = await paymentGateway({
      key: options.key,
      amount: options.amount,
      order_id: options.id,
      name: "Paveo",
      description: "Order Payment",

      prefill: {
        name: options?.user_info?.customer_name,
        email: options?.user_info?.email_id,
        contact: options?.user_info?.mobile_no,
      },
    });

    return { status: "success", paymentData };
    // Send paymentData.razorpay_payment_id to backend for verification
  } catch (err) {
    return { status: "error", error: err };
  }
};
